import { render, staticRenderFns } from "./ExceptionPage.vue?vue&type=template&id=5cb709cc&scoped=true"
import script from "./ExceptionPage.vue?vue&type=script&lang=ts"
export * from "./ExceptionPage.vue?vue&type=script&lang=ts"
import style0 from "./ExceptionPage.vue?vue&type=style&index=0&id=5cb709cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb709cc",
  null
  
)

export default component.exports